// extracted by mini-css-extract-plugin
export default {"container":"BE-z","modal":"CE-z","dimensions":"DE-z","brandName":"EE-z","productName":"FE-z","labelValue":"GE-z","recipientEmail":"HE-z","recommendedFit":"IE-z","hiddenField":"JE-z"};